import { GET_ALL_FINS_SUCCESS, GET_ALL_FINS_FAIL, LOGOUT, GET_ALL_FINS_REQUEST } from "./types";

import finService from "../services/finService";
export const getAllFinances = () => async (dispatch) => {
  dispatch({ type: GET_ALL_FINS_REQUEST });
  try {
    const res = await finService.getAllFin();
    dispatch({
      type: GET_ALL_FINS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: GET_ALL_FINS_FAIL,
      payload: err.response.data.error,
    });
  }
};

// export const force = () => (dispatch) => {
//   finService.logout();

//   dispatch({
//     type: LOGOUT,
//   });
// };
